import { createRequest, platform } from "@shared/platform-api/requests"
import { createRequestHook } from "../../createRequestHook"
import { FleetInsights, UseGetFleetInsightsInput } from "./types"
import { usePolicyAndFleet } from "../../../contexts"
import { isNewPipelinePolicy } from "../../../utils"
import { useApi } from "../../../contexts/hooks/useApi"

const getFleetInsights = createRequest<UseGetFleetInsightsInput, FleetInsights>(
  async (input: UseGetFleetInsightsInput, getToken): Promise<FleetInsights> => {
    const useNewPipeline = isNewPipelinePolicy(input.policyId)

    return platform(getToken).fleetInsights.getFleetInsights({
      ...input,
      ...(useNewPipeline ? { dbName: `athena` } : {}),
    })
  }
)

const useGetFleetInsights = createRequestHook<UseGetFleetInsightsInput, FleetInsights>(getFleetInsights)

export const useFleetInsights = () => {
  const { policy } = usePolicyAndFleet()
  const [res, reload] = useGetFleetInsights({ policyId: policy.id })
  return useApi<FleetInsights, UseGetFleetInsightsInput>(res, reload)
}
